// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3zX9h","tab":"ProcedureTabs_tab__3-x1p"};